var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle_complete_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle_complete_svg__cls-1{fill:#327b9d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle_complete_svg__cls-1",
    d: "M24.47.21l8.73 5.68L42.01.34l4.72 9.28 10.4-.4-.56 10.4 9.22 4.85-5.68 8.73 5.56 8.81-9.29 4.72.4 10.4-10.4-.56-4.85 9.22-8.73-5.68-8.81 5.56-4.72-9.29-10.4.4.56-10.4-9.22-4.85 5.68-8.73-5.55-8.81 9.28-4.72-.4-10.4 10.4.56L24.47.21z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle_complete.c111044fef67295b2e669c6ce637a349.svg";